import React from "react";
import "./Contact.css";

const Contact = () => {
  const phoneNumber = "9727983039";
  const whatsappNumber = "919727983039";
  const email = "contact@multifct.online";

  return (
    <div className="hm-contact-page">
      {/* Dark Top Hero Banner */}
      <section className="hm-contact-hero">
        <div className="hm-contact-hero-inner">
          <span className="hm-contact-tag">GET IN TOUCH</span>
          <h1 className="hm-contact-title">Let's talk with us</h1>
          <p className="hm-contact-subtitle">
            Questions, bulk enquiries or delivery details — reach MultiFct directly.
          </p>
        </div>
      </section>

      {/* Main 2-Column Content on Subtle Grid */}
      <section className="hm-contact-body">
        <div className="hm-contact-grid-container">
          {/* LEFT COLUMN: 4 Contact Cards */}
          <div className="hm-contact-left-col">
            {/* Card 1: WhatsApp */}
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noreferrer"
              className="hm-info-card"
            >
              <div className="hm-info-card-icon hm-icon-wa">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.5 3.5A11.7 11.7 0 0 0 12.1 0C5.6 0 .3 5.3.3 11.8c0 2.1.5 4.1 1.6 5.9L.2 24l6.4-1.7a11.8 11.8 0 0 0 5.5 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.1 21.7c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.8 9.8 0 1 1 8.5 4.7Zm5.4-7.4c-.3-.2-1.7-.9-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.1-1.4-.1-.1-.3-.2-.6-.4Z" />
                </svg>
              </div>
              <div className="hm-info-card-text">
                <h3 className="hm-card-main-title">WhatsApp</h3>
                <p className="hm-card-sub-title">Chat with us instantly</p>
                <span className="hm-card-value-link hm-val-green">
                  +91 {phoneNumber}
                </span>
              </div>
            </a>

            {/* Card 2: Call */}
            <a href={`tel:+91${phoneNumber}`} className="hm-info-card">
              <div className="hm-info-card-icon hm-icon-call">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div className="hm-info-card-text">
                <h3 className="hm-card-main-title">Call</h3>
                <p className="hm-card-sub-title">Mon–Sat, 10am–7pm</p>
                <span className="hm-card-value-link hm-val-green">
                  +91 {phoneNumber}
                </span>
              </div>
            </a>

            {/* Card 3: Email */}
            <a href={`mailto:${email}`} className="hm-info-card">
              <div className="hm-info-card-icon hm-icon-email">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect width="20" height="16" x="2" y="4" rx="2" />
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                </svg>
              </div>
              <div className="hm-info-card-text">
                <h3 className="hm-card-main-title">Email</h3>
                <p className="hm-card-sub-title">We reply within a day</p>
                <span className="hm-card-value-link hm-val-green">{email}</span>
              </div>
            </a>

            {/* Card 4: Visit / Registered Office */}
            <div className="hm-info-card hm-card-address">
              <div className="hm-info-card-icon hm-icon-pin">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </div>
              <div className="hm-info-card-text">
                <h3 className="hm-card-main-title">Registered Office</h3>
                <p className="hm-card-sub-title">
                  Road No. 04, Nr. Kotak Bank, Sachin
                </p>
                <span className="hm-card-value-address">
                  Surat, Gujarat - 394230, India
                </span>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: Map & Trademark Table */}
          <div className="hm-contact-right-col">
            {/* Google Map Box */}
            <div className="hm-map-box">

              <iframe
                title="Google Map Location"
                src="https://maps.google.com/maps?q=Road+No+04,Nr+Kotak+Bank,Sachin,Surat,Gujarat,394230&t=&z=14&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                className="hm-map-iframe"
              ></iframe>
            </div>

            {/* Trademark & Ownership Card */}
            <div className="hm-trademark-card">
              <h2 className="hm-trademark-title">Trademark &amp; ownership</h2>

              <div className="hm-trademark-table">
                <div className="hm-tm-row">
                  <span className="hm-tm-label">Brand / Trade Mark</span>
                  <span className="hm-tm-value">MultiFct</span>
                </div>

                <div className="hm-tm-row">
                  <span className="hm-tm-label">Application No</span>
                  <span className="hm-tm-value">15554166 (FORM TM-A)</span>
                </div>

                <div className="hm-tm-row">
                  <span className="hm-tm-label">Class</span>
                  <span className="hm-tm-value">Class 1</span>
                </div>

                <div className="hm-tm-row hm-tm-row-goods">
                  <span className="hm-tm-label">Goods / Service</span>
                  <span className="hm-tm-value hm-tm-goods">
                    Waterproof adhesive glue included in class-1.
                  </span>
                </div>

                <div className="hm-tm-row">
                  <span className="hm-tm-label">Status</span>
                  <span className="hm-tm-value hm-tm-status">
                    Proposed to be used
                  </span>
                </div>

                <div className="hm-tm-row">
                  <span className="hm-tm-label">Firm</span>
                  <span className="hm-tm-value">Murlidhar Enterprise</span>
                </div>

                <div className="hm-tm-row">
                  <span className="hm-tm-label">Proprietor</span>
                  <span className="hm-tm-value">Hirenkumar Hiteshbhai Jodhani</span>
                </div>

                <div className="hm-tm-row">
                  <span className="hm-tm-label">Jurisdiction</span>
                  <span className="hm-tm-value">Ahmedabad</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
